import { Notes } from '../shared/notes';
import { useP21UserContext } from '../../context/p21-user-context';
import { useEffect, useMemo, useState } from 'react';
import { useNotificationContext } from '../shared/notification';
import { NotesAPI } from '../../api/notes';
import { Item } from './item-types';

const itemNotesAdditionalColumns = [
  { id: 'topic', label: 'Subject', cellSx: { width: '150px' } },
];

export const ItemNotes = ({ item }: { item: Item }) => {
  const { useExceptionHandler } = useNotificationContext();

  const [itemNotes, setItemNotes] = useState([]);
  const { permissions } = useP21UserContext();
  const reloadNotes = useExceptionHandler(async () => {
    const { data: newNotes } = await NotesAPI.get({
      type: 'ITEM',
      noteEntityKey: `${item.item_id}`,
      lineNumber: undefined,
    });
    setItemNotes(newNotes);
  });
  useEffect(() => {
    reloadNotes();
  }, [item.item_id]);


  const notesData = useMemo(
    () => ({
      notes: itemNotes,
      noteEntityKey: `${item.inv_mast_uid}`,
      noteType: 'ITEM',
      defaultArea: 'Item Maintenance',
    }),
    [itemNotes]
  );

  return (
    <>
      <Notes
        showSearch
        data={notesData}
        onNotesModified={reloadNotes}
        additionalColumns={itemNotesAdditionalColumns}
        style={{ height: '300px' }}
        hasPermissionToEdit={permissions.isSupplyChain}
        canCreateNewNotes={true}
      />
    </>
  );
};
